import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import './i18n';
import reportWebVitals from './reportWebVitals';

// Forçar tema Paris (dark-sidebar) como padrão se nenhum layout salvo
if (!localStorage.getItem('sidebar_layout')) {
  localStorage.setItem('sidebar_layout', 'compact-wrapper dark-sidebar');
}
// Cor primária padrão
if (!localStorage.getItem('default_color')) {
  document.documentElement.style.setProperty('--theme-deafult', '#7366ff');
  document.documentElement.style.setProperty('--theme-secondary', '#f73164');
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
